import * as actions from '../utils/Constants';

export const updateUserContext = (id) => {
    return {
        type: actions.UPDATE_USER_CONTEXT,
        payload: fetch(process.env.REACT_APP_API_HOST + `api/auth/currentsession/${id}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        }).catch(error => {
            return Promise.reject(error);
        })
    }
}
